"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.string.trim.js");

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _projections = require("ol/proj/projections");

var _map = require("../../../../util/map");

var _useGetProjection3 = _interopRequireDefault(require("../../../../hooks/projection/useGetProjection"));

var _usePrevious = _interopRequireDefault(require("../../../../hooks/common/usePrevious"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["placeholder", "allowClear", "onSelectProjection", "onSelect", "onChange", "onClearProjection", "onSearch", "registerSelectedProjection", "value", "delay", "fetchOpts", "defaultValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Component to allow a selection of a projection through a 
 * list of projections retrieved dynamically through the 
 * autocomplete.
 * 
 * Check <a href="https://ant.design/components/auto-complete/">
 * Antd AutoComplete</a> component for additional properties.
 * 
 * @visibleName Get Projection AutoComplete 
 */
var GetProjectionAutoComplete = function GetProjectionAutoComplete(_ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select a projection" : _ref$placeholder,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? true : _ref$allowClear,
      _ref$onSelectProjecti = _ref.onSelectProjection,
      onSelectProjection = _ref$onSelectProjecti === void 0 ? null : _ref$onSelectProjecti,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? null : _ref$onSelect,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? null : _ref$onChange,
      _ref$onClearProjectio = _ref.onClearProjection,
      onClearProjection = _ref$onClearProjectio === void 0 ? null : _ref$onClearProjectio,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? null : _ref$onSearch,
      _ref$registerSelected = _ref.registerSelectedProjection,
      registerSelectedProjection = _ref$registerSelected === void 0 ? true : _ref$registerSelected,
      value = _ref.value,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 1000 : _ref$delay,
      fetchOpts = _ref.fetchOpts,
      defaultValue = _ref.defaultValue,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      setCurrentProjection = _useState4[1];

  var _useGetProjection = (0, _useGetProjection3.default)(),
      _useGetProjection2 = _slicedToArray(_useGetProjection, 4),
      sendRequest = _useGetProjection2[0],
      clearRequest = _useGetProjection2[1],
      projections = _useGetProjection2[2],
      timeoutId = _useGetProjection2[3];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultValueWasUsed = _useState6[0],
      setDefaultValueWasUsed = _useState6[1];

  var previousValue = (0, _usePrevious.default)(value);

  if (value !== previousValue && value !== currentValue) {
    setCurrentValue(value);
  }

  var onInternalSelect = (0, _react.useCallback)(function (value, option) {
    setCurrentValue(value);
    setCurrentProjection(option);
    onSelect && onSelect(value, option); //register projection if not registered

    var projectionCode = "EPSG:".concat(option.projection.code);
    var projection = (0, _projections.get)(projectionCode);

    if (registerSelectedProjection && !projection) {
      projection = (0, _map.registerProjection)(projectionCode, option.projection.proj4);
    } //call event handler


    onSelectProjection && onSelectProjection(value, option.projection, projection);
  }, [onSelectProjection, onSelect, registerSelectedProjection]);
  var onInternalChange = (0, _react.useCallback)(function (value) {
    setCurrentValue(value);
    onChange && onChange(value);
    onClearProjection && value === '' && onClearProjection();
  }, [onChange, onClearProjection]);
  var onInternalSearch = (0, _react.useCallback)(function (value) {
    if (value && value.length > 0) {
      clearTimeout(timeoutId);
      sendRequest(value, delay, fetchOpts);
    }

    onSearch && onSearch(value);
  }, [onSearch, sendRequest, delay, timeoutId, fetchOpts]);
  /**
   * Effect to send the request to retrieve the projections based on the default value
   */

  (0, _react.useEffect)(function () {
    if (!currentValue && !projections && defaultValue) {
      if (defaultValue.trim().length > 0) {
        sendRequest(defaultValue, 0, fetchOpts);
      }
    }

    return function () {//clearTimeout(timeoutId);
    };
  }, [currentValue, defaultValue, projections, sendRequest, fetchOpts]);
  /**
   * Effect to retrieve the projections based on the default value 
   * from the previous request
   * 
   */

  (0, _react.useEffect)(function () {
    if (!currentValue && projections && defaultValue && !defaultValueWasUsed) {
      if (projections.length > 0) {
        setCurrentValue(projections[0].value);
        setDefaultValueWasUsed(true); //register projection if not registered

        var projectionCode = "EPSG:".concat(projections[0].projection.code);
        var projection = (0, _projections.get)(projectionCode);

        if (registerSelectedProjection && !projection) {
          projection = (0, _map.registerProjection)(projectionCode, projections[0].projection.proj4);
        } //call event handler


        onSelectProjection && onSelectProjection(projections[0].value, projections[0].projection, projection); //clear request

        clearRequest();
      }
    }
  }, [currentValue, defaultValue, projections, clearRequest, onSelectProjection, defaultValueWasUsed, registerSelectedProjection]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.AutoComplete, _objectSpread({
    value: currentValue,
    options: projections,
    allowClear: allowClear,
    onSelect: onInternalSelect,
    onChange: onInternalChange,
    onSearch: onInternalSearch,
    placeholder: placeholder
  }, otherProps));
};

GetProjectionAutoComplete.propTypes = {
  /**
   * The placeholder for the autocomplet component.
   */
  placeholder: _propTypes.default.string,

  /**
   * Show the clear button to clear the input
   */
  allowClear: _propTypes.default.bool,

  /**
   * Called when a option is selected. param is option's value and option instance
   * @ignore
   */
  onSelect: _propTypes.default.func,

  /**
   * Called when a option is selected. param is projection option's value, 
   * the <i>object</i> projection and, if the projection is registered,
   * the openlayers ol/Projection
   */
  onSelectProjection: _propTypes.default.func,

  /**
   * Called when select an option or input value change, 
   * or value of input is changed. The param is the input value.
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Called when the input value is cleared or it is an empty string.
   */
  onClearProjection: _propTypes.default.func,

  /**
   * Called when searching items
   * @ignore
   */
  onSearch: _propTypes.default.func,

  /**
   * Selected projection
   */
  value: _propTypes.default.string,

  /**
   * time delay (in milliseconds) to send the autocomplete request,
   * to avoid that a request will be sent everytime
   * the user type a letter.
   */
  delay: _propTypes.default.number,

  /**
   * Additional options to be used for the 
   * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch">fetch API</a>.
   */
  fetchOpts: _propTypes.default.object,

  /**
   * Initial selected projection
   */
  defaultValue: _propTypes.default.string,

  /**
   * If the selected projection is not defined and 
   * this parameter is true, the selected projection will
   * be registered
   */
  registerSelectedProjection: _propTypes.default.bool
};
var _default = GetProjectionAutoComplete;
exports.default = _default;